var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c("div", { staticClass: "ci-slider-section-wrapper my-3 my-lg-4" }, [
    _c(
      "div",
      {
        staticClass: "ci-slider-section-wrapper__inner py-3 py-md-4 px-lg-4",
        class: _vm.variants,
      },
      [
        _vm.headline
          ? _c("h3", {
              staticClass: "h5 headline mx-3 mx-sm-4 mx-lg-0 mb-2 mb-md-3",
              domProps: { textContent: _vm._s(_vm.headline) },
            })
          : _vm._e(),
        _c("div", { staticClass: "row" }, [_vm._t("slider")], 2),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }